/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthNote } from './PalReauthNote';
import {
    PalReauthNoteFromJSON,
    PalReauthNoteFromJSONTyped,
    PalReauthNoteToJSON,
    PalReauthNoteToJSONTyped,
} from './PalReauthNote';

/**
 * 
 * @export
 * @interface SavePalReauthNote200Response
 */
export interface SavePalReauthNote200Response {
    /**
     * 
     */
    data?: PalReauthNote | null;
}

/**
 * Check if a given object implements the SavePalReauthNote200Response interface.
 */
export function instanceOfSavePalReauthNote200Response(value: object): value is SavePalReauthNote200Response {
    return true;
}

export function SavePalReauthNote200ResponseFromJSON(json: any): SavePalReauthNote200Response {
    return SavePalReauthNote200ResponseFromJSONTyped(json, false);
}

export function SavePalReauthNote200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavePalReauthNote200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] === undefined ? undefined : json['data'] === null ? null : PalReauthNoteFromJSON(json['data']),
    };
}

export function SavePalReauthNote200ResponseToJSON(json: any): SavePalReauthNote200Response {
    return SavePalReauthNote200ResponseToJSONTyped(json, false);
}

export function SavePalReauthNote200ResponseToJSONTyped(value?: SavePalReauthNote200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalReauthNoteToJSON(value['data']),
    };
}

